import {usePackageRestrictionContext} from "~/common/components/PackageRestrictionContext/PackageRestrictionContext";
import {useSalesData} from "~/SalesCampaign/useSalesData";
import {PackagingSelectionVariant} from "~/common/components/PackagingSelection/PackagingSelectionVariant";
import {useDispatch} from "react-redux";
import {useMemo} from "react";
import {addMessage} from "~/redux/globalMessages/actions";
import type {ProductDescriptor} from "~/feature/ProductDescriptor/v1/types";

interface Props {
  product: ProductDescriptor;
  variant: PackagingSelectionVariant;
}

export const usePackagingSelectionLogic = ({ product, variant }: Props) => {
  const dispatch = useDispatch();

  const restrictedCode = usePackageRestrictionContext();
  const salesData = useSalesData();

  return useMemo(() => {
    const packagingOptions = product?.availability?.packagingInformation ?? null;

    if (!packagingOptions || !product.isLoaded) {
      return null;
    }

    let options = packagingOptions;
    if (restrictedCode) {
      options = options.filter((option) => restrictedCode === option.packCode);
    }

    if (options.length === 0) {
      dispatch(addMessage("info", "restrictedPackaging.notFound", "translation"));
      return packagingOptions;
    }

    if (variant === PackagingSelectionVariant.Campaign) {
      const validPackageCodes = new Set(Object.keys(salesData?.salePerPack ?? {}));
      options = options.filter((option) => validPackageCodes.has(option.packCode));
    }

    return options;
  }, [
    [product.isAvailabilityLoading, restrictedCode, variant, salesData, product?.availability?.packagingInformation],
  ]);
};
